<template>
    <div class="network-error">
        <img class="icon-img" :src="iconImg" />
        <h1>加载失败</h1>
        <p>暂无内容显示</p>
        <a v-if="showRefresh" @click="refresh">刷新</a>
    </div>
</template>

<script>
import { stopBodyScroll } from '@/util/dom';
export default {
    props: {
        showRefresh: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            iconImg: require('../../assets/images/fail_default.png'),
        };
    },
    mounted() {
        stopBodyScroll(true);
    },
    methods: {
        refresh() {
            const reloadUrl = this.$route.query.reload;
            if (reloadUrl) {
                window.location.replace(reloadUrl);
            } else {
                window.location.reload();
            }
        }
    },
    destroyed() {
        stopBodyScroll(false);
    }
};
</script>

<style scoped lang="less">
@import '~src/assets/css/mixin.less';
@import '~src/assets/css/variable.less';
.network-error {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 10000;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #FFFFFF;
    .icon-img {
        width: 320 * @layout375;
        height: 220 * @layout375;
    }
    h1 {
        font-weight: normal;
        font-size: 16 * @layout375;
        line-height: 22 * @layout375;
        text-align: center;
        color: #9B9DA9;
    }
    p {
        margin-top: 10 * @layout375;
        font-weight: normal;
        font-size: 14 * @layout375;
        line-height: 20 * @layout375;
        text-align: center;
        color: #CDCED4;
    }
    a {
        margin-top: 30 * @layout375;
        margin-bottom: 60 * @layout375;
        text-decoration: none;
        font-weight: normal;
        font-size: 16 * @layout375;
        line-height: 22 * @layout375;
        text-align: center;
        color: #00BEBE;
    }
}
</style>



// WEBPACK FOOTER //
// src/marketing_components/network-error/index.vue